import { Component, OnInit, Input, Output, EventEmitter, signal } from '@angular/core';
import { RuleCondition } from '../../classes/rule-service/rule-condition';
import { Site } from '../../classes/site';
import { Gateway } from '../../classes/gateway';
import { RuleAction } from '../../classes/rule-service/rule-action';
import { AdminExportService } from 'app/shared/admin-export.service';

@Component({
  selector: 'app-rule-action-picker',
  templateUrl: './rule-action-picker.component.html',
  styleUrls: ['./rule-action-picker.component.css'],
  standalone: false
})
export class RuleActionPickerComponent implements OnInit {

  @Output()
  submit: EventEmitter<RuleAction> = new EventEmitter<RuleAction>();

  @Output()
  cancel: EventEmitter<any> = new EventEmitter<any>();

  _modifyAction: RuleAction;

  @Input()
  public set modifyAction(value: RuleAction) {
    if (value) {
      this._modifyAction = value;
      this.action = 'modify';
    }
  }

  action: any;
  details: string;

  @Input()
  defaultGateway: Gateway;

  @Input()
  defaultSite: Site;

  operate = signal<boolean>(false);

  equpiment = signal<any>(null);
  payloads = signal<any[]>(null);

  newAlarmRasied = signal<boolean>(true);
  resolvedlarm = signal<boolean>(true);

  trigger: 'new' | 'resolved' = 'new';

  constructor(private adminExportService: AdminExportService) { }

  ngOnInit() {
  }


  triggerSelected(trigger: 'new' | 'resolved') {
    console.log(trigger);
    this.trigger = trigger;
  }

  deviceActionClick(eq) {
    console.log(`deviceActionClick`, eq);
    this.operate.set(null);
    const action = new RuleAction({
      method: 'operate',
      trigger: this.trigger, device_action_id: eq.id,
      device_title: eq.device.title,
      device_action_title: eq.title, device_action_gateway_id: eq.device.gatewayId
    });

    this.submit.emit(action);
  }

  newAction(typeOfCondition: string) {
    switch (typeOfCondition) {
      case 'operate':
        this.operate.set(true);
        this.adminExportService.getActionsForRules().then((actions) => {
          this.equpiment.set(actions);
        });
        break;
      default:
        this.operate.set(false);
        this.action = { action: 'new', type: typeOfCondition };
        this.details = 'New Condition';
        break;
    }
  }

  newRuleActionSubmitted(action: RuleAction) {
    this.action = null;
    this.submit.emit(action)
  }

  newRuleActionCancelled() {
    this.action = null;
    this.cancel.emit();
  }

  newRuleHours() {
    this.action = 'restrict-hours';
  }
}
